import { Ordersnew } from "./ordersNew";

export class OrdersUpdate {
  public operationName: string = "";
  public axwayPassword: string = "";
  public apiKey: string = "";
  public statusCode: string = "";
  public orders: Array<Ordersnew> = [];
}
